import { useDispatch, useSelector } from 'react-redux';

import { GlobalState } from 'reactApp/core/rootReducer';

export const ReduxHooks = {
    useSelector<TState extends GlobalState, TSelected>(
        selector: (state: TState) => TSelected,
        equalityFn?: (left: TSelected, right: TSelected) => boolean,
    ) {
        return useSelector(selector, equalityFn);
    },
    useDispatch,
};
